import {Suspense, lazy} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import BillingRouter from './internal/BillingRouter'
import {DashboardRouter} from './internal/DashboardRouter'
import ManagementsRouter from './internal/ManagementsRouter'
import {ProviderRouter} from './internal/ProviderRouter'
import SettingsRouter from './internal/SettingsRouter'
import {SupportRouter} from './internal/SupportRouter'
import PrincipalRouter from './internal/PrincipalRouter'

const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))

const ProceduresPage = lazy(() => import('../pages/procedures/ListProcedures'))
const ProfileClinic = lazy(() => import('../pages/providers/clinics/ProfileClinic'))
const TermsAndConditions = lazy(() => import('../pages/terms-and-conditions/TermsAndConditions'))

const AuditPage = lazy(() => import('../pages/audit/ListAudit'))

export function PrivateRoutes() {
    return (
        <Suspense fallback={<FallbackView />}>
            <Routes>
                <Route path='/principal/*' element={<PrincipalRouter />} />

                <Route path='/account/*' element={<AccountPage />} />
                <Route path='/estabelecimento/*' element={<ProfileClinic />} />
                <Route path='/termos-e-condicoes/*' element={<TermsAndConditions />} />

                <Route path='/exames/*' element={<ProceduresPage />} />

                <Route path='/prestadores/*' element={<ProviderRouter />} />

                <Route path='/gestao/*' element={<ManagementsRouter />} />

                <Route path='/financeiro/*' element={<BillingRouter />} />

                <Route path='/auditoria/*' element={<AuditPage />} />

                <Route path='/suporte/*' element={<SupportRouter />} />

                <Route path='/configuracoes/*' element={<SettingsRouter />} />

                <Route
                    path='/autenticacao/entrar'
                    element={<Navigate to='/dashboard/administrativo' replace />}
                />

                <Route path='/*' element={<DashboardRouter />} />
            </Routes>
        </Suspense>
    )
}
